<div class="container">
  <!-- Header toolbar -->
  <mat-toolbar class="cim-primary">
    @if (utilisateur$ | async; as utilisateur) {
      <mat-toolbar-row>
        <div class="nav-button-row">
          <!-- <button mat-icon-button (click)="sidenav.toggle()" >
          <mat-icon>{{ sidenav?.opened ? 'close' : 'menu' }}</mat-icon>
        </button> -->
        <!-- <img
        src="../../assets/img/CIMSUP_logo_154x150.png"
        alt="Cimsup"
        class="logo"
        /> -->
        @if (!utilisateur.NonAccesEnrplan) {
          <button
            mat-mini-fab
            color="primary"
            aria-label="save"
            (click)="save()"
            [matTooltip]="'Sauver'"
            >
            <mat-icon>save</mat-icon>
          </button>
        }
        <button
          mat-mini-fab
          color="primary"
          aria-label="refresh"
          (click)="refresh()"
          [matTooltip]="'Rafraîchir'"
          >
          <mat-icon>refresh</mat-icon>
        </button>
        <!-- <button
          mat-mini-fab
          aria-label="Ordres de Fabrication"
          (click)="goTo('of-list')"
          [matTooltip]="'Ordres de Fabrication'"
          >
          <mat-icon>assignment</mat-icon>
        </button> -->
        @if (activeVue() === 'GANTT') {
          <button
            mat-mini-fab
            aria-label="Param"
            (click)="goTo('param')"
            [matTooltip]="'Param'"
            >
            <mat-icon>settings</mat-icon>
          </button>
        }
        @if (activeVue() === 'PARAM') {
          <button
            mat-mini-fab
            aria-label="Gantt"
            (click)="goTo('gantt')"
            [matTooltip]="'Gantt'"
            >
            <mat-icon>calendar_view_day</mat-icon>
          </button>
        }
        <!-- <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Menu export"
        *ngIf="activeVue() === 'GANTT'"
        >
        <mat-icon>file_download</mat-icon>
      </button> -->
      <mat-menu #menu="matMenu">
        <button
          mat-menu-item
          aria-label="Close"
          (click)="export('EXCEL')"
            matTooltip="
      Export EXCEL
    "
          >
          <mat-icon>grid_on</mat-icon>
          <span>Export EXCEL</span>
        </button>
        <button
          mat-menu-item
          aria-label="Close"
          (click)="export('PDF')"
            matTooltip="
        Export PDF
      "
          >
          <mat-icon>picture_as_pdf</mat-icon>
          <span>Export PDF</span>
        </button>
        <button
          mat-menu-item
          aria-label="Close"
          (click)="export('PNG')"
            matTooltip="
        Export PNG
      "
          >
          <mat-icon>image</mat-icon>
          <span>Export PNG</span>
        </button>
      </mat-menu>
      @if (activeVue() === 'GANTT') {
        <mat-divider
          [vertical]="true"
          style="display: inline"
          class="jalon"
        ></mat-divider>
      }
      @if (activeVue() === 'GANTT') {
        <button
          mat-icon-button
          aria-label="Close"
          (click)="closeOpenAll(1)"
          class="jalon"
          [matTooltip]="
            !openCenters ? 'Fermer tous les centres' : 'Ouvrir tous les centres'
          "
          >
          <mat-icon>adjust</mat-icon>
        </button>
      }
      @if (activeVue() === 'GANTT') {
        <button
          mat-icon-button
          aria-label="Close"
          (click)="closeOpenAll(2)"
          [matTooltip]="
            !openPostes ? 'Fermer tous les postes' : 'Ouvrir tous les postes'
          "
          >
          <mat-icon>vertical_align_center</mat-icon>
        </button>
      }
      @if (activeVue() === 'GANTT' && !utilisateur.NonAccesExejalon) {
        <mat-divider
          [vertical]="true"
          style="display: inline"
          class="jalon"
        ></mat-divider>
      }
      @if (activeVue() === 'GANTT' && !utilisateur.NonAccesExejalon) {
        <button
          class="jalon"
          mat-raised-button
          color="primary"
          aria-label="jalon"
          (click)="jalon()"
          [matTooltip]="'Jalonnement global'"
          >
          {{ "Jalonnement" }}
        </button>
      }
      @if (activeVue() === 'GANTT') {
        <button
          mat-icon-button
          aria-label="logs"
          (click)="openLogs()"
        [matTooltip]="
         'logs du Jalonnement'
        "
          >
          <mat-icon>summarize</mat-icon>
        </button>
      }
      @if (activeVue() === 'GANTT') {
        <mat-divider
          [vertical]="true"
          style="display: inline"
          class="jalon"
        ></mat-divider>
      }
      @if (activeVue() === 'GANTT') {
        <mat-radio-group
          style="margin-left: 30px"
          aria-label="Select an option"
          (change)="viewTypechange($event)"
          >
          <mat-radio-button #showType value="1">Tout</mat-radio-button>
          <mat-radio-button #showType value="2">Semaine</mat-radio-button>
        </mat-radio-group>
      }
      @if (activeVue() === 'GANTT') {
        <button
          class="jalon"
          mat-stroked-button
          color="primary"
          aria-label="zoom in"
          (click)="zoomIn()"
          [matTooltip]="'zoom in'"
          >
          {{ "Zoom in" }}
        </button>
      }
      @if (activeVue() === 'GANTT') {
        <button
          mat-stroked-button
          color="primary"
          aria-label="zoom out"
          (click)="zoomOut()"
          [matTooltip]="'zoom out'"
          >
          {{ "Zoom out" }}
        </button>
      }
    </div>
    <span class="spacer"></span>
    <span class="cim-navbar-title" i18n="@@ProductionSchedule"
      >Production Schedule</span
      >
      @if (spin) {
        <i style="margin-left: 10px">
          Chargement en cours, veuillez patienter ...
        </i>
      } @else {
        @if (activeVue() === 'GANTT') {
          <h6 class="nbtasks">
            <i>{{ nbTasks() }}</i>
          </h6>
        }
      }
      <span>
        <!-- <mat-spinner [diameter]="40" *ngIf="spin"  style="margin-left: 10px;"></mat-spinner> -->
      </span>
      <span class="spacer"></span>
      <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon>{{ sidenav?.opened ? "close" : "search" }}</mat-icon>
      </button>
      <button
        mat-icon-button
        routerLink="login"
        routerLinkActive="active"
        [matTooltip]="'Login'"
        >
        <mat-icon>account_circle</mat-icon>
      </button>
    </mat-toolbar-row>
  }
</mat-toolbar>
<!-- Main view -->
<mat-drawer-container class="drawer">
  <!-- Sidenav -->
  <mat-drawer #sidenav mode="over" closed color="primary" [position]="'end'">
    <!-- Nested menu -->
    @if (ganttModel$ | async; as ganttModel) {
      <form
        class="example-form"
        [formGroup]="searchFormGroup"
        >
        <h2>Filtres</h2>
        @for (property of ganttModel.properties; track property) {
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>{{ property.label }}</mat-label>
            <input
              matInput
              [placeholder]="property.label"
              [formControl]="getControl(property)"
              />
            </mat-form-field>
          }
          <button
            mat-raised-button
            color="primary"
            (click)="loadGantt(searchFormGroup.value)"
            >
            Ok
          </button>
        </form>
      }
    </mat-drawer>

    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </mat-drawer-container>
</div>
